import { useContext } from 'react';

import TranslationContext from './context';

export function useTranslate() {
	const { t } = useContext(TranslationContext);

	return { t };
}

/**
 * @deprecated Use `useTranslate` instead.
 */
export function useTranslationFn() {
	const { t } = useTranslate();

	return t;
}
